var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Organization50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M42,42H6V10c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4V42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#64B5F6",
    d: "M6 42H42V44H6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M31 27H37V32H31zM21 27H27V32H21zM11 27H17V32H11zM31 35H37V40H31zM11 35H17V40H11zM31 19H37V24H31zM21 19H27V24H21zM11 19H17V24H11zM31 11H37V16H31zM21 11H27V16H21zM11 11H17V16H11zM21 35H27V44H21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Organization50);
export default __webpack_public_path__ + "static/media/icons8-organization-50.b2c35638d034b0b89f6389b041913faf.svg";
export { ForwardRef as ReactComponent };